import React from "react";
import { Col, Container, Row, Label, Input } from "reactstrap";

import ReactCodeInput from "react-code-input";
//assets
import logo from "../../../assets/image/logo.svg";

function Code() {
  return (
    <section className="lyt-section typ-login">
      <Container>
        <Row className="align-items-center justify-content-center">
          <Col xs={12} sm={12} md={12} lg={6} xl={5}>
            <div className="bs-card typ-login">
              <div className="img-area">
                <picture>
                  <source media="(max-width:992px)" srcSet={logo} />
                  <img src={logo} alt="GLYPHER TECH LOGO" />
                </picture>
              </div>
              <form className="bs-form">
                <p className="otp-desc">
                  <strong>+91******7890</strong>{" "}
                </p>

                <div className="input-area">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginbottom: 50,
                    }}
                  >
                    <ReactCodeInput
                      type="tel"
                      fields={6}
                      className="ReactCodeInput otp-input-wrapper"
                      inputStyle={{
                        fontFamily: "roboto",
                        MozAppearance: "textfield",
                        width: "41px",
                        borderRadius: "5px",
                        fontSize: "20px",
                        height: "41px",
                        paddingLeft: "0px",
                        backgroundColor: "white",
                        border: "1px solid rgba(0,0,0,0.4)",
                        outline: "none",
                        textAlign: "center",
                        margin: "2px",
                      }}
                      id="code"
                      placeholder="123456"
                      required
                    />
                  </div>
                </div>

                <button
                  style={{ marginTop: 30 }}
                  className="bs-btn typ-login"
                  type="submit"
                >
                  Sign In
                </button>
              </form>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Code;
